import { BoxV2 as Box, Flex, Table } from 'portal-commons';
import { FunctionComponent, JSX } from 'react';
import { TableRow } from '@material-ui/core';

interface TableRowSelectorProps<T> {
  headRows?: {
    id: string;
    label: string;
    sortable: boolean;
  }[];
  error?: boolean;
  note?: string;
  options?: T[];
  renderRow?: (option: T) => JSX.Element;
}

const Container: FunctionComponent = ({ children, ...props }) => (
  <Flex
    sx={{
      flexDirection: 'column',
      gap: 'xxs',
      width: '100%',
      '& table': {
        minWidth: 'unset',
      },
    }}
    {...props}
  >
    {children}
  </Flex>
);

const TableRowSelector = <T,>({
  headRows = [],
  error = false,
  note,
  options = [],
  renderRow = () => <TableRow />,
  ...props
}: TableRowSelectorProps<T>) => {
  return (
    <Container {...props}>
      <Table
        disableHover
        loading={false}
        headRows={headRows}
        headerTextTransform="none"
        tableData={options.map((option) => renderRow(option))}
        emptyState=""
      />
      {note && (
        <Box
          className="error-msg"
          sx={{
            color: error ? '#B70505' : 't.black60',
            fontWeight: 400,
            fontSize: 'H100',
          }}
          data-testid="helperText"
        >
          {note}
        </Box>
      )}
    </Container>
  );
};

export default TableRowSelector;
